import { useQuery } from '@tanstack/react-query';

import { useLogErrorPublicWeb } from '@telialt/utils/src/datadog/useLogError';

import { loadMinimalNavigationItems } from '../api';
import { QUERY_KEY } from '../constants';

export const useNavigationItemsQuery = (routes: string[]) => {
    const {
        data: navigationItems,
        isLoading: isLoadingNavigationItems,
        isError: isErrorNavigationItems,
        error: errorNavigationItems,
    } = useQuery({
        queryKey: [QUERY_KEY.NAVIGATION_ITEMS, routes],
        queryFn: () => loadMinimalNavigationItems(routes),
        enabled: routes.length > 0,
    });
    useLogErrorPublicWeb(errorNavigationItems);

    return { navigationItems, isLoadingNavigationItems, isErrorNavigationItems, errorNavigationItems };
};
